module.exports = __webpack_public_path__ + "img/driver-empty-img3.3509d4df.png";